import { styled } from '@core-ui/react-stitch';
import useBRRedesign from '../../../../hooks/features/useBRRedesign/useBRRedesign';
import { SMALL, MEDIUM, LARGE, XLARGE } from '@core-ui/breakpoint-provider';

const styles = {
  "small": {
    height: "6.25rem",
    padding: "0 0.5rem 0.5rem 0.5rem",
  },
  "medium": {
    height: "7.25rem",
    padding: "0 0.5rem 0.5rem 0.5rem",
  },
  "large": {
    height: "7.25rem",
    padding: "0 1rem 1rem 1rem",
  },
  "x-large": {
    height: "7.25rem",
    padding: "0 1.25rem 1.25rem 1.25rem",
  },
};

// eslint-disable-next-line complexity
const getBreakPoint = ({ isSmall, isMedium, isXLarge }) => {
  if(isSmall) {
    return SMALL;
  }
  if(isMedium) {
    return MEDIUM;
  }
  if(isXLarge) {
    return XLARGE;
  }
  return LARGE;
}

const getDynamicStyles = breakPoints => {
  const breakPoint = getBreakPoint(breakPoints)
  const style = styles[breakPoint];
  return style;
};

const WrapperStyles = styled.div(({ breakPoints }) => ({
  ...getDynamicStyles(breakPoints),
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
}));

export const ProductInfoWrapper = ({ children, breakPoints }) => (
  <>
    {useBRRedesign() ? (
      <WrapperStyles breakPoints={breakPoints}>{children}</WrapperStyles>
    ) : (
      children
    )}
  </>
);
